import React, { useState, useRef } from "react";
import GooglePlayBlack from "../../assets/GooglePlayBlack.png";
import AppleStoreBlack from "../../assets/AppleStoreBlack.png";
import SubscribeEmailModal from "../modals/SubscribeEmailModal";
import "./eventnews.css";

const EventNews = () => {
  const [email, setEmail] = useState(""); // State for the email field
  const [message, setMessage] = useState(""); // Feedback message
  const [isFocused, setIsFocused] = useState(false); // Track focus state
  const [showModal, setShowModal] = useState(false); // State for showing the modal
  const formRef = useRef(null);
  const emailRef = useRef(null);

  // Handle subscribe action
  const handleSubscribe = (e) => {
    e.preventDefault();

    // Email validation using a regex pattern
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Show error if email is empty
    if (!email.trim()) {
      setMessage("Email is required.");
      return;
    }

    // Show error if email format is invalid
    if (!emailRegex.test(email)) {
      setMessage("Please enter a valid email address.");
      return;
    }

    // Clear the email field after submission
    setEmail(""); // Clear state
    setIsFocused(false); // Remove focus
    emailRef.current.textContent = ""; // Clear contentEditable field

    // Show the modal after successful subscription
    setShowModal(true);
  };

  // Update email and clear error message while typing
  const handleEmailChange = (e) => {
    const newEmail = e.currentTarget.textContent;
    setEmail(newEmail);

    // Clear the error message if the user starts typing
    if (newEmail.trim()) {
      setMessage(""); // Clear error message if email is being typed
    }
  };

  // Close modal handler
  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div
      className="container rounded-4 border py-5 my-5 d-flex flex-column justify-content-center align-items-center"
      style={{ background: "#F9F9F9" }}
    >
      <h1 className="fw-bold text-center NewsHead" style={{ fontSize: "4rem" }}>
        Events & News
      </h1>
      <p className="text-center">
        Get the latest news about Gift cards through GiftCard8 Blog
      </p>

      <div
        className="custom-container rounded-4 border d-flex flex-column justify-content-center align-items-center m-5 px-5"
        style={{
          height: "30vh",
        }}
      >
        <form
          ref={formRef}
          action="https://giftcard8.us22.list-manage.com/subscribe/post?u=09bbbc662b17b0fb88ebf9c5a&amp;id=eeb0f7c08f&amp;f_id=00d8c2e1f0"
          method="POST"
          className="w-100 eventForm m-2"
        >
          <div
            className="w-100 mb-3 custom-email-input d-flex align-items-center justify-content-center"
            style={{
              border: "1px solid #ced4da",
              borderRadius: ".375rem",
              padding: "0 10px",
              height: "60px",
              background: "#fff",
              position: "relative",
            }}
            onClick={() => emailRef.current?.focus()}
          >
            <div
              contentEditable
              ref={emailRef}
              role="textbox"
              className="w-100"
              style={{
                outline: "none",
                textAlign: "center",
              }}
              onInput={handleEmailChange} // Handle email input change
              onFocus={() => setIsFocused(true)}
              onBlur={() => {
                if (!email.trim()) setIsFocused(false);
              }}
            />
            {!email && !isFocused && (
              <div
                style={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  textAlign: "center",
                  color: "#5D5D5D",
                }}
              >
                Enter email
              </div>
            )}
          </div>

          {/* Hidden Mailchimp Field to prevent bot signups */}
          <input type="hidden" name="EMAIL" value={email} />

          <div className="d-flex justify-content-center align-items-center">
            <button
              type="submit"
              className="btn btn-primary w-100 w-md-50 w-lg-25"
              onClick={handleSubscribe}
            >
              Subscribe
            </button>
          </div>
        </form>

        {/* Show error message if email is empty or invalid */}
        {message && <p className="text-danger">{message}</p>}
      </div>

      <h2 className="fw-bold text-center mt-4">Download the App</h2>
      <div className="my-4 d-flex gap-2">
        <a
          href="https://play.google.com/store/apps/details?id=com.yihua.giftcard"
          target="_blank"
          rel="noopener noreferrer"
          alt="Google Play Store"
        >
          <img
            src={GooglePlayBlack}
            alt="Google Play"
            className="my-2 hover-effect playStore"
            style={{ maxWidth: "250px", height: "auto" }}
          />
        </a>
        <a
          href="https://apps.apple.com/ng/app/GiftCard8Exch/id6476837359"
          target="_blank"
          rel="noopener noreferrer"
          alt="Apple Store"
        >
          <img
            src={AppleStoreBlack}
            alt="Apple Store"
            className="my-2 hover-effect playStore"
            style={{ maxWidth: "250px", height: "auto" }}
          />
        </a>
      </div>

      {/* Subscribe Email Modal */}
      <SubscribeEmailModal show={showModal} onClose={handleCloseModal} />
    </div>
  );
};

export default EventNews;
